module.exports = __webpack_public_path__ + "static/zapier-dfd03f194e4c59422ce75b7f4b2df54c.svg";